<h2 data-cy="cookie-consent-dialog" mat-dialog-title class="mb-3">Consent to Cookies & Data processing</h2>
<ng-container *ngIf="state === 'form'">
  <div mat-dialog-content class="!min-h-[80px] overflow-y-hidden">
    <span class="mb-2 text-secondary line-clamp-2">
      We use cookies and related tracking technologies to improve the way our site functions for you<br/>as a visitor.
    </span>
    <mat-checkbox [(ngModel)]="essentialCookiesChecked" disabled="true">
      Necessary
    </mat-checkbox>
  </div>
  <div class="" mat-dialog-actions align="start">
    <button data-cy="cookie-consent-accept-all" type="submit" mat-flat-button color="primary" (click)="acceptAll()">
      Accept all
    </button>
  </div>
  <div class="flex w-full align-center justify-center mt-8">
    <a data-cy="cookie-consent-details-link" (click)="state = 'details'">Cookies</a>
  </div>
</ng-container>

<ng-container *ngIf="state === 'details'">
  <div mat-dialog-content>
    <table class="w-full">
      <thead>
        <tr>
          <th class="w-30 text-left p-4 pl-0">Cookie name</th>
          <th class="w-40 text-left p-4">Example value</th>
          <th class="text-left p-4">Expire</th>
          <th class="text-left p-4">Type</th>
          <th class="text-left p-4">Domain</th>
          <th class="text-left p-4">Provider</th>
        </tr>
      </thead>
      <tbody>
      <tbody>
        <tr>
          <td class="p-4 pl-0">_cf_bm</td>
          <td class="p-4">-</td>
          <td class="p-4">30 minutes</td>
          <td class="p-4">Strictly Necessary</td>
          <td class="p-4">.hs-scripts.com</td>
          <td class="p-4">Cloudflare</td>
        </tr>
        <tr>
          <td class="p-4 pl-0">_cf_bm</td>
          <td class="p-4">-</td>
          <td class="p-4">30 minutes</td>
          <td class="p-4">Strictly Necessary</td>
          <td class="p-4">.hubspot.com</td>
          <td class="p-4">Cloudflare</td>
        </tr>
        <tr>
          <td class="p-4 pl-0">_cf_bm</td>
          <td class="p-4">-</td>
          <td class="p-4">30 minutes</td>
          <td class="p-4">Strictly Necessary</td>
          <td class="p-4">.hsadspixel.net</td>
          <td class="p-4">Cloudflare</td>
        </tr>
        <tr>
          <td class="p-4 pl-0">_cf_bm</td>
          <td class="p-4">-</td>
          <td class="p-4">30 minutes</td>
          <td class="p-4">Strictly Necessary</td>
          <td class="p-4">.hs-analytics.net</td>
          <td class="p-4">Cloudflare</td>
        </tr>
        <tr>
          <td class="p-4 pl-0">_cf_bm</td>
          <td class="p-4">-</td>
          <td class="p-4">30 minutes</td>
          <td class="p-4">Strictly Necessary</td>
          <td class="p-4">.hs-banner.com</td>
          <td class="p-4">Cloudflare</td>
        </tr>
        <tr>
          <td class="p-4 pl-0">_cf_bm</td>
          <td class="p-4">-</td>
          <td class="p-4">30 minutes</td>
          <td class="p-4">Strictly Necessary</td>
          <td class="p-4">.usemessages.com</td>
          <td class="p-4">Cloudflare</td>
        </tr>
        <tr>
          <td class="p-4 pl-0">_hssc</td>
          <td class="p-4">-</td>
          <td class="p-4">30 minutes</td>
          <td class="p-4">Performance</td>
          <td class="p-4">sociuu.sociuu.app</td>
          <td class="p-4">HubSpot</td>
        </tr>
        <tr>
          <td class="p-4 pl-0">_hssrc</td>
          <td class="p-4">1</td>
          <td class="p-4">Session</td>
          <td class="p-4">Performance</td>
          <td class="p-4">sociuu.sociuu.app</td>
          <td class="p-4">HubSpot</td>
        </tr>
        <tr>
          <td class="p-4 pl-0">_hstc</td>
          <td class="p-4">-</td>
          <td class="p-4">6 months</td>
          <td class="p-4">Performance</td>
          <td class="p-4">sociuu.sociuu.app</td>
          <td class="p-4">HubSpot</td>
        </tr>
        <tr>
          <td class="p-4 pl-0">_gcl_au</td>
          <td class="p-4">-</td>
          <td class="p-4">2 months 4 weeks</td>
          <td class="p-4">Targeting</td>
          <td class="p-4">.sociuu.app</td>
          <td class="p-4">Google</td>
        </tr>
        <tr>
          <td class="p-4 pl-0">hubspotutk</td>
          <td class="p-4">-</td>
          <td class="p-4">6 months</td>
          <td class="p-4">Functionality</td>
          <td class="p-4">sociuu.sociuu.app</td>
          <td class="p-4">HubSpot</td>
        </tr>
        <tr>
          <td class="p-4 pl-0">_cluid</td>
          <td class="p-4">-</td>
          <td class="p-4">Session</td>
          <td class="p-4">Functionality</td>
          <td class="p-4">.hubspot.com</td>
          <td class="p-4">HubSpot</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="mt-4 pt-0 pb-0 mb-0" mat-dialog-actions align="start">
    <button data-cy="cookie-consent-back" type="submit" mat-stroked-button color="white" (click)="state = 'form'">
      Back
    </button>
  </div>
</ng-container>